<template>
  <div>
    <el-form :model="formData" label-width="180px" :rules="rules">
      <el-row>
        <el-form-item label="物件番号：" >
          <el-input class="inputStyle" v-model="formData.wujian_id" disabled></el-input>
        </el-form-item>
        <el-form-item label="楼层：" >
          <el-input class="inputStyle" v-model="formData.floor" disabled></el-input>
        </el-form-item>
        <el-form-item label="排产楼层：" >
          <el-input class="inputStyle" v-model="formData.scheduling_floor" disabled></el-input>
        </el-form-item>
      </el-row>
        <el-row>
          <el-form-item label="重量(KG)：" >
            <el-input class="inputStyle" v-model="formData.weight" disabled></el-input>
          </el-form-item>
          <el-form-item label="单元个数(个)：" >
            <el-input class="inputStyle" v-model="formData.unit_num" disabled></el-input>
          </el-form-item>
          <el-form-item label="面积(㎡)：" >
            <el-input class="inputStyle" v-model="formData.area" disabled></el-input>
          </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="先行楼层：" >
          <el-select v-model="formData.advance_floor" placeholder="先行楼层" style="width: 120px" clearable>
            <el-option v-for="dict in advanceFloorDataList" :key="dict.value" :label="dict.label" :value="dict.value"></el-option>
          </el-select>
        </el-form-item>
      </el-row>
      <el-form-item label="关联批号：">
        <el-select v-model="formData.associated_batch_no" style="width: 720px" clearable multiple>
          <el-option v-for="dict in batchNoDataList" :key="dict.value" :label="dict.label" :value="dict.value"></el-option>
        </el-select>
      </el-form-item>
      <el-row v-for="item in formData.lineListAll" style="margin-top: 20px;margin-left: 40px" :key="item.id">
        <el-col :span="4">
          <span style="color: #606266;">{{ item.line_name }}(日产量)：</span>
        </el-col>
        <el-col :span="20">
          <el-select v-model="item.letter" style="width: 720px;margin-left: -20px;" clearable>
            <el-option v-for="dict in item.letterList" :key="dict.letter" :label="dict.letter + ' '+ (dict.remark == undefined?'': '(' +dict.remark + ')') + ' ' + '产量：' + dict.value" :value="dict.letter"></el-option>
          </el-select>
        </el-col>
      </el-row>
      <el-form-item></el-form-item>
      <el-row>
        <el-col :span="24" style="text-align: center">
          <el-button type="success" @click="updateFloorInfo" :loading="loading">保存</el-button>
        </el-col>
      </el-row>
    </el-form>

  </div>
</template>

<script>
import {nanoid} from 'nanoid'
export default {
  name: "MfgFloorInOfEdit",
  props: {
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    setting: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      loading:false,
      batchNoDataList:[],
      cnt:0,
      formData:{
      },
      advanceFloorDataList:[],
      zuLiPlanDateList:[],
      rules: {
        star: [{required: true, message: '', trigger: 'blur'}],
      },
    }
  },
  computed: {
    stateList() {
      return this.$store.getters['core/getDictList']('window_error_states');
    }
  },
  methods:{
    getAdvanceFloor(){
      this.$axios.post('mfg/floor/getAdvanceFloor', this.formData).then(response => {
        let res = response.data
        this.advanceFloorDataList = res.data
      })
    },
    getList() {
      this.formData = this.parentData
      this.$axios.post('mfg/floor/zuLiPlanDateList', this.parentData.id).then(response => {
        let res = response.data
        this.zuLiPlanDateList = res.data

        if (this.zuLiPlanDateList.length == 0 ){
          this.addFiveZuLiPlanDate()
        }

      })
    },
    async getBatchAllList() {
      this.$axios.post('mfg/floor/batchAll', this.formData).then(response => {
        let res = response.data
        this.batchNoDataList = res.data
      })
    },
    updateFloorInfo(){
      for (let item of this.formData.lineListAll) {
        if (item.letter === undefined || item.letter === null) {
          return this.$message.error(""+item.line_name+"日产线量为空")
        }
      }
      this.loading = true
      this.formData.zuLiPlanDateList = this.zuLiPlanDateList
      this.$axios.post('mfg/floor/updateFloorInfo', this.formData).then(response => {

        let res = response.data
        if (res.code !== 0) {
          return this.$message.error(res.message);
        }
        this.loading = false
        this.setting.$fn.closeWindow();
        this.setting.$fn.reSearch();
        return this.$message.success('编辑成功!');
      })
    },
    getLineList() {
      this.$axios.post('mfg/wuJianInfo/getLineList',this.formData).then(response => {
        let res = response.data
        if (res.code !== 0) {
          return this.$message.error(res.message);
        }

        this.formData.lineListAll = res.data.lineListAll;
        for (let item of this.formData.lineListAll) {
          for (let item1 of res.data.lineList) {
              if (item.id == item1.line_id) {
                item.letter =  item1.letter
              }
          }
        }
      }, error => {
        this.$message.error(`页面数据加载失败` + error.message);
      })
    },
  },created() {
    this.getList()
    this.getBatchAllList()
    this.getLineList()
    this.getAdvanceFloor()
  }
}
</script>

<style scoped>
.inputStyle{
  width: 120px;
}
.dateItemStyle{
  width: 150px;
}
.height {
  line-height: 40px;
  height: 40px;
}
</style>